import { render } from "./Callminutes.vue?vue&type=template&id=8b8f1954"
const script = {}
script.render = render

export default script